<template>
  <v-card>
    <v-card-title>Blogs</v-card-title>

    <ListCard :items='blogs' />
  </v-card>
</template>

<script>
import store from '../store'
import ListCard from './ListCard'

export default {
  name: 'Blogs',
  components: {
    ListCard,
  },
  data(){
    return {
      blogs: [
        {
          src: '/img/blogs/vue.jpeg',
          alt: 'https://osmantamer.medium.com/vue-js-crop-upload-and-display-profile-picture-6bffb2e79fae',
          name: 'Vue.js Crop, Upload and Display Profile Picture',
          summary: 'A short description to implement profile picture selection and uploading profile pictures on the server.',
          dialog: false,
          details: false,
          clickable: true
        }
      ]
    }
  }
}
</script>

<style>

</style>